module.exports = __webpack_public_path__ + "img/no-resistence-training.d766e5bd.svg";